// Production configuration for jpro.app
export const PRODUCTION_CONFIG = {
  CHAT_API: '5785|BFp8rBz1MMP0DvecsNvNZIGQKxu9dUNimkWftesGccc20b76',
  API_URL: 'https://api.jpro.app/api/v1',

  MODEL_SERVICE_URL: 'https://jpro-rag-py-g0d9hwabe5b8ctct.eastus2-01.azurewebsites.net',

  GOOGLE_CLIENT_ID: '437632205205-peocgmvn9en6pqmpisfthgjutun7jli7.apps.googleusercontent.com',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBkRGKPuMzdEDES-rKgK17vCBiKwkgfczY', // set at deploy time via Vercel/Azure env → mirrored here
  // Vector Map ID for the admin Session Map (enables Advanced Markers + light/dark).
  // Create in Google Cloud → Maps Platform → Map Management (Rendering: Vector).
  // DEMO_MAP_ID is Google's shared demo config — replace with a real Map ID for production.
  GOOGLE_MAPS_MAP_ID: 'b1f32ecca7eb15462c1ee96d',
  MICROSOFT_CLIENT_ID: '80990e51-2ad9-4199-88e5-368123d17e36',
  MICROSOFT_TENANT_ID: 'common',
  MICROSOFT_REDIRECT_URI: 'https://jpro.app',
  SIGNALR_URL: 'https://jpro-signalr.service.signalr.net',
  // Stripe publishable key — public by design (safe to ship in the bundle).
  // Override per-environment via VITE_STRIPE_PUBLISHABLE_KEY for sandbox/test.
  STRIPE_PUBLISHABLE_KEY: 'pk_live_51TMsi9DZ62WiCByxSZws8rAIKBf7QGj4Uq5MlrdgqkH85UO4pmRX6rf8VHEmi1bjZcGER3q5QOImZOK3mAdNHvqp00yy5SixmC'
};

// Resolve config values with env-var overrides on top of baked-in defaults.
// PRODUCTION_CONFIG carries the values that ship with the bundle (legacy from
// cPanel where build-time env injection wasn't possible). Environments that
// *can* inject env vars at build time (Vite dev, Vercel, Azure SWA via the
// GitHub workflow) override the baseline per-key.
export const getConfig = (key) => {
  const envMap = {
    CHAT_API: import.meta.env.VITE_CHAT_API,
    API_URL: import.meta.env.VITE_API_URL,
    MODEL_SERVICE_URL: import.meta.env.VITE_MODEL_SERVICE_URL,
    SIGNALR_URL: import.meta.env.VITE_SIGNALR_URL,
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    GOOGLE_MAPS_MAP_ID: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,
    MICROSOFT_CLIENT_ID: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
    MICROSOFT_TENANT_ID: import.meta.env.VITE_MICROSOFT_TENANT_ID,
    MICROSOFT_REDIRECT_URI: import.meta.env.VITE_MICROSOFT_REDIRECT_URI,
    STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
  };

  return envMap[key] ?? PRODUCTION_CONFIG[key];
};